const actions = {
  APP_USER_BOOTSTRAP: 'APP_USER_BOOTSTRAP',
  APP_USER_BOOTSTRAP_SUCCESS: 'APP_USER_BOOTSTRAP_SUCCESS',
  APP_USER_BOOTSTRAP_ERROR: 'APP_USER_BOOTSTRAP_ERROR',

  appUserBootstrap: () => ({
    type: actions.APP_USER_BOOTSTRAP,
  }),

  appUserBootstrapSuccess: () => ({
    type: actions.APP_USER_BOOTSTRAP_SUCCESS,
  }),

  appUserBootstrapError: () => ({
    type: actions.APP_USER_BOOTSTRAP_ERROR,
  }),
};

export default actions;
